export { CompareIcon } from './compare'
